module.exports = __webpack_public_path__ + "assets/bin_2.481c0d9d.svg";